import { createSlice } from "@reduxjs/toolkit";
import {
  getMultimediaGroupsList,
  getMultimediaPosts,
  likeMultimediaPost,
} from "../../actions";
import {
  getMultimediaGroupsListFunctions,
  getMultimediaPostsFunctions,
  likeMultimediaPostFunctions,
} from "./functions";

const {
  getMultimediaGroupsListPending,
  getMultimediaGroupsListFulfilled,
  getMultimediaGroupsListRejected,
} = getMultimediaGroupsListFunctions;
const {
  getMultimediaPostsFunctionsPending,
  getMultimediaPostsFunctionsFulfilled,
  getMultimediaPostsFunctionsRejected,
} = getMultimediaPostsFunctions;
const {
  likeMultimediaPostFunctionsPending,
  likeMultimediaPostFunctionsFulfilled,
  likeMultimediaPostPostsFunctionsRejected,
} = likeMultimediaPostFunctions;

const initialState = {
  getMultimediaGroupsList: {
    isLoading: false,
    error: null,
    data: null,
  },
  getMultimediaPosts: {
    isLoading: false,
    error: null,
    data: null,
  },
};

const multimediaGroupsSlice = createSlice({
  name: "multimediaGroups",
  initialState,
  reducers: {
    setPost: (state, action) => {
      state.getPost.data = action.payload;
    },
    // Clear the shared getMultimediaPosts error. This slot is shared between the
    // general Video section and every Course sub-page, and the error is otherwise
    // only cleared by a `pending` action — which the fetch throttle frequently
    // skips on in-app re-entry, leaving a stale "Ops! errore" toast. Course pages
    // dispatch this on view-enter so a previous failure can't haunt the next visit.
    clearMultimediaPostsError: (state) => {
      state.getMultimediaPosts.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getMultimediaGroupsList.pending,
      getMultimediaGroupsListPending,
    );
    builder.addCase(
      getMultimediaGroupsList.fulfilled,
      getMultimediaGroupsListFulfilled,
    );
    builder.addCase(
      getMultimediaGroupsList.rejected,
      getMultimediaGroupsListRejected,
    );

    builder.addCase(
      getMultimediaPosts.pending,
      getMultimediaPostsFunctionsPending,
    );
    builder.addCase(
      getMultimediaPosts.fulfilled,
      getMultimediaPostsFunctionsFulfilled,
    );
    builder.addCase(
      getMultimediaPosts.rejected,
      getMultimediaPostsFunctionsRejected,
    );

    builder.addCase(
      likeMultimediaPost.pending,
      likeMultimediaPostFunctionsPending,
    );
    builder.addCase(
      likeMultimediaPost.fulfilled,
      likeMultimediaPostFunctionsFulfilled,
    );
    builder.addCase(
      likeMultimediaPost.rejected,
      likeMultimediaPostPostsFunctionsRejected,
    );
  },
});

export const { setPost, setComment, clearMultimediaPostsError } =
  multimediaGroupsSlice.actions;
export default multimediaGroupsSlice.reducer;
